const activityLog = {};
const MAX_LENGTH = 50;
export const logActivity = (uaId, type, data, message) => {
    if (!activityLog[uaId]) {
        activityLog[uaId] = [];
    }
    const event = Object.assign(Object.assign({ type }, data), { timestamp: Date.now() });
    if (message) {
        event.message = message;
    }
    activityLog[uaId].push(event);
    if (activityLog[uaId].length > MAX_LENGTH) {
        activityLog[uaId].shift();
    }
};
export const getActivityLog = () => {
    const log = {};
    Object.keys(activityLog).forEach((key) => {
        log[key] = activityLog[key].sort((a, b) => b.timestamp - a.timestamp);
    });
    return log;
};
